module.exports = __webpack_public_path__ + "static/media/mnz.75f46eec.svg";